SNIPPETS

<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>

        <div class="d-flex justify-content-between align-items-center mb-2">
            <div class=""></div>
            <div class="">
                <b-button
                    variant="primary"
                    size="sm"
                    @click="getList"
                    :disabled="loading"
                >Refresh</b-button>
            </div>
        </div>
        
        <b-table
            :items="tenants"
            :fields="fields"
            :busy="loading"
            :responsive="true"
            :small="true"
            class=""
        >
            <template #cell(name)="data">
                <a :href="data.item.hq_tenant_detail_url" class="font-weight-bold">{{data.value}}</a>
            </template>
            <template #cell(is_active)="data">
                <b-icon :icon="data.value ? 'check-circle-fill' : 'x-circle-fill'" :variant="data.value ? 'success' : 'danger'"></b-icon>
            </template>
            <template #cell(config_errors)="data">
                <span :class="data.item.config_errors.length > 0 ? 'text-danger font-weight-bold' : ''">{{ data.value }}</span>
            </template>
            <template #cell(actions)="data">
                <b-button-group
                    size="sm"
                >
                    <b-button
                        :disabled="!data.item.hq_create_first_tu_url"
                        :href="data.item.hq_create_first_tu_url"
                        variant="light-primary"
                    >Create Initial TUs</b-button>
                    <b-button
                        :href="data.item.base_url"
                        target="_blank"
                        variant="light-secondary"
                    >Internal Dashboard</b-button>
                    <b-button
                        :href="data.item.django_admin_url"
                        target="_blank"
                        variant="light-secondary"
                    >Django Admin</b-button>
                    <b-button
                        variant="gray-primary"
                        @click="createAdminTu(data.item.id)"
                    >Create Admin TU</b-button>
                </b-button-group>

            </template>
        </b-table>
    </div>
</template>

<script>
import { suppliosHqApi } from '../../js/api-service';
import { 
    // FormatDateTimeHelper, 
    FormatDateHelper,
} from '../../js/filters-helpers';

export default {
    name: 'HqTenantList',
    components: {},
    props: {
        
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            loading: false,
            tenants: [],  // list from API will go here
            fields: [
                {key:'name', label: 'Name', sortable: true},
                {key:'plan_name', label: 'Plan', sortable: true},
                {key:'subdomain', label: 'Subdomain', sortable: true},
                //{key:'org_sid'},
                {key:'is_active', label: 'Is Active?', sortable: true},
                {key:'total_tu_count', label: 'Total TUs', sortable: true},
                {key:'internal_tu_count', label: 'Internal TUs', sortable: true},
                {key:'external_tu_count', label: 'External TUs', sortable: true},
                // {key:'config_errors', label: 'Name', formatter: (value) => value.length},  // value is an array of strings -- REMOVED FOR NOW, TOO EXPENSIVE ON BACKEND & not very useful
                {key:'actions', label: 'Actions'},  // for buttons
                {key:'created', label: 'Created', sortable: true, formatter: 'formatDate'},
            ],
        }
    },
    computed: {

    },
    mounted: function() {
        this.getList();
    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        getList: function() {
            this.loading = true;
            return suppliosHqApi.tenants.list()
                .then(response => {
                    this.tenants = response.data;
                    return true;
                })
                .catch(err => {
                    this.handleError(err, 'Error while getting tenant list');
                    return false;
                })
                .then(success => {
                    this.loading = false;
                    return success;
                })
        },
        formatDate: function(value) {
            return FormatDateHelper(value);
        },
        async createAdminTu(tenantId) {
            // create the Supplios Admin TU for this tenant USING CURRENT USER 
            // this is idempotent - will return msg about any current TU in this tenant for current user
            try {
                const resp = await suppliosHqApi.tenants.create_supplios_admin_tu(tenantId);
                const successMsg = resp.data;  // just a message string for now
                this.$toast.success(successMsg);
            } catch (error) {
                console.log('Error while creating admin TU');
                console.log(error.response);
                this.$toast.error('Error - check console log');
            }
        },
    }
}
</script>

<style>

</style>